<link rel="stylesheet" href="/v2/assets/static/smart-coaching/articles.css">
@if (showHeaderFooter) {
  <div id="header" class="o-mobile-page__header">
    <div class="c-table">
      <div class="c-table__cell valign-bottom">
        <h2 header="health-profile" class="c-heading-mobile">{{ pageHeaderTextStringId | translate}}</h2>
      </div>
    </div>
  </div>
}

<div class="o-mobile-page article">
  <div class="o-mobile-page__body has-footer" [ngClass]="showHeaderFooter ? 'has-header' : ''">
    <div [innerHTML]="articleContents"></div>

    @if (isArticleRatingFeatureEnabled) {
      <div class="c-article-rating">
        <div class="c-article-rating__controls">
          <div class="c-article-rating__text" id="articleRatingText">
            {{wasThisHelpfulStringId | translate}} 
          </div>
          <div class="c-article-rating__icons">
            <button id="articleRatingPositive" type="button" class="c-thumb-btn" [ngClass]="{'is-active': this.feedback === 'positive-feedback'}" (click)="this.selectFeedback('positive-feedback')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="c-svg c-svg--thumb-up-24 c-svg--baseline">
                <path d="M1 21h4v-12h-4v12zM23 10c0-1.1-0.9-2-2-2h-6.31l0.95-4.57 0.030-0.32c0-0.41-0.17-0.79-0.44-1.060l-1.060-1.050-6.58 6.59c-0.37 0.36-0.59 0.86-0.59 1.41v10c0 1.1 0.9 2 2 2h9c0.83 0 1.54-0.5 1.84-1.22l3.020-7.050c0.090-0.23 0.14-0.47 0.14-0.73v-2z"></path>
              </svg>
            </button>
            <button id="articleRatingNegative" type="button" class="c-thumb-btn" [ngClass]="{'is-active': this.feedback === 'negative-feedback'}"(click)="this.selectFeedback('negative-feedback')">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="c-svg c-svg--thumb-down-24 c-svg--baseline">
                <path d="M15 3h-9c-0.83 0-1.54 0.5-1.84 1.22l-3.020 7.050c-0.090 0.23-0.14 0.47-0.14 0.73v2c0 1.1 0.9 2 2 2h6.31l-0.95 4.57-0.030 0.32c0 0.41 0.17 0.79 0.44 1.060l1.060 1.050 6.59-6.59c0.36-0.36 0.58-0.86 0.58-1.41v-10c0-1.1-0.9-2-2-2zM19 3v12h4v-12h-4z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    }
    </div>
</div>

@if (showHeaderFooter) {
  <div class="o-mobile-page__footer">
    <div class="c-table">
      <div class="c-table__cell valign-bottom">
        @if (!valid) {
          <p class="c-survey__error u-margin-bottom-small" error="error-message">{{ validationTextStringId | translate }}</p>
        }
        <div><button id="continueButton" type="button" (click)="this.continueSelected()" class="c-btn c-btn--primary">{{ continueText | translate }}</button></div>
        @if (cancelText) {
          <div class="u-padding-top"><button id="cancelButton" type="button" (click)="this.cancelSelected()" class="c-btn">{{ cancelText | translate }}</button></div>
        }
      </div>
    </div>
  </div>
}
